module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-wrap-max",
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    staticClass: "sp-wrap-max-inner"
  }, [_c('section', {
    staticClass: "sp-boarding-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-boarding-centered"
  }, [_vm._m(0), _vm._v(" "), (_vm.onboarding) ? _c('div', {
    staticClass: "col-md-12 onboarding"
  }, [_c('div', {}, [_c('div', {
    staticClass: "sp-pan-inner-block-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "sp-pan-inner-block"
  }, [_c('div', {
    staticClass: "sp-onboarding-block"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setupAccount('sp')
      }
    }
  }, [_vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-pan-inner-block"
  }, [_c('div', {
    staticClass: "sp-onboarding-block"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.setupAccount('bp')
      }
    }
  }, [_vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]) : _vm._e(), _vm._v(" "), (_vm.sp_set) ? _c('div', {
    staticClass: "sp-boarding-full-wrap"
  }, [(_vm.sp_set_layout) ? _c('div', {}, [_c('div', {
    staticClass: "sp-pan-inner-block",
    staticStyle: {
      "padding": "2em"
    }
  }, [_c('h6', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("How would like your Sellpoint to look like?")]), _vm._v(" "), _c('div', {
    staticClass: "sp-pan-interests"
  }, [_c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(1)
      }
    }
  }, [_c('b', [_vm._v("Shop")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display my products and services)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(2)
      }
    }
  }, [_c('b', [_vm._v("Services")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display services I offer)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(3)
      }
    }
  }, [_c('b', [_vm._v("Gallery")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display my events and colections)")])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-bp-interest-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectSellpointLayout(4)
      }
    }
  }, [_c('b', [_vm._v("Blog")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(display my posts and stories)")])])])])])]) : _c('div', [_c('div', {}, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.add_sellpoint) ? _c('div', [_c('h6', [_vm._v("Add New Sellpoint")]), _vm._v(" "), (!_vm.add_business) ? _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Add an Existing Sellpoint")]), _vm._v(" "), _c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Username "), (!_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addExistingSellpoint
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('br'), _c('br')]) : _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Select an Existing Sellpoint")]), _vm._v(" "), _c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_user_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.sellpoints), function(sellpoint) {
    return _c('option', {
      domProps: {
        "value": sellpoint.business_username
      }
    }, [_vm._v(_vm._s(sellpoint.business_name))])
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addSelectedExistingSellpoint
    }
  }, [_vm._v("Add")])])]), _vm._v(" "), _c('br'), _c('br')]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Or Add A New Sellpoint")]), _vm._v(" "), _c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Or Select Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  }))]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addNewSellpoint
    }
  }, [_vm._v("Add New Sellpoint")])])])])]) : _c('div', [_c('h6', [_vm._v("Create Sellpoint")]), _vm._v(" "), _c('form', {
    staticClass: "sp-forms-one"
  }, [_c('ul', {
    staticClass: "row"
  }, [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Name\r\n                                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_name),
      expression: "business.business_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.business.business_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" *Business Username "), (_vm.validate_user_name_error) ? _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.validate_user_name_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_user_name),
      expression: "business.business_user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.business.business_user_name)
    },
    on: {
      "change": _vm.validateUserName,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.business.business_user_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), (!_vm.group_isset) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v(" Sellpoint Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.market_category),
      expression: "business.market_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.market_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.market_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.mk_category_id
      }
    }, [_vm._v(_vm._s(category.mk_category_name))])
  }))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.business.business_view_layout == 2) ? _c('div', [_c('li', [_c('label', [_vm._v(" Business Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  }))])]) : _c('div', [_c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select Business Category Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business_category_type),
      expression: "business_category_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business_category_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Services")])])]), _vm._v(" "), (_vm.business_category_type == 1) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select a Product Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_product_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.business_category_type == 2) ? _c('li', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Select a Service Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.business.business_category),
      expression: "business.business_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.business.business_category = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.business_service_categories), function(category) {
    return _c('option', {
      domProps: {
        "value": category.category_id
      }
    }, [_vm._v(_vm._s(category.category_name))])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createSellpoint
    }
  }, [_vm._v("Create")])])])])])])])])])]), _vm._v(" "), (!_vm.not_onboarding) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelSetupAccount
    }
  }, [_vm._v(" << Back")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bp_set) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('div', {
    staticClass: "sp-pan-left-inner"
  }, [_c('div', {
    staticClass: "padding-top-10 padding-bottom-10"
  }, [_c('div', {
    staticClass: "sp-inner-form-wrap"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), _c('div', [_c('h6', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Setting up your Buypoint ...")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("What are you interested in?")]), _vm._v(" "), _c('div', {
    staticClass: "bp-interest-block"
  }, [_c('ul', _vm._l((_vm.categories), function(category) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.bp_interests),
        expression: "bp_interests"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": category.category_id,
        "checked": Array.isArray(_vm.bp_interests) ? _vm._i(_vm.bp_interests, category.category_id) > -1 : (_vm.bp_interests)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.bp_interests,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = category.category_id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.bp_interests = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.bp_interests = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.bp_interests = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(category.category_name) + "\r\n                                ")])
  })), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createBuypoint
    }
  }, [_vm._v("Proceed")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelSetupAccount
    }
  }, [_vm._v(" << Back")])])])])])])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(6)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-image text-center"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/logo-w.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-pan-inner-block"
  }, [_c('div', {
    staticClass: "sp-onboarding-block"
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Which would like to do first?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("You can always set up the remaining accounts anytime")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Setup a Sellpoint Seller Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h6', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Setup a Buypoint Buyer Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sp-footer-2"
  }, [_c('div', {
    staticClass: "foot-links"
  }, [_c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "info#about"
    }
  }, [_vm._v("How to use")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('p', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("©  2015 Sellpoint. All rights reserved. ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll"
  }, [_c('a', {
    staticClass: "go-up",
    attrs: {
      "href": "#wrap"
    }
  }, [_c('i', {
    staticClass: "lnr lnr-arrow-up"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7257c66b"}!./src/pages/CreateSellpoint/template.html
// module id = 289
// module chunks = 0